export const startPanelResize = ({
    event,
    panelRef,
    sizeKey,
    sizeRef,
    setSize,
    minWidth,
    minHeight
}) => {
    event.preventDefault();
    event.stopPropagation();
    const panel = panelRef.current;
    if (!panel) return;
    const rect = panel.getBoundingClientRect();
    sizeRef.current = {
        startX: event.clientX,
        startY: event.clientY,
        startWidth: rect.width,
        startHeight: rect.height
    };
    const handleMove = (moveEvent) => {
        if (!sizeRef.current) return;
        const dx = moveEvent.clientX - sizeRef.current.startX;
        const dy = moveEvent.clientY - sizeRef.current.startY;
        const nextWidth = Math.min(
            window.innerWidth - 40,
            Math.max(minWidth, sizeRef.current.startWidth + dx)
        );
        const nextHeight = Math.min(
            window.innerHeight - 40,
            Math.max(minHeight, sizeRef.current.startHeight + dy)
        );
        const nextSize = { width: nextWidth, height: nextHeight };
        sizeRef.current.lastSize = nextSize;
        setSize(nextSize);
    };
    const handleUp = () => {
        if (sizeRef.current?.lastSize) {
            localStorage.setItem(sizeKey, JSON.stringify(sizeRef.current.lastSize));
        }
        sizeRef.current = null;
        window.removeEventListener('mousemove', handleMove);
        window.removeEventListener('mouseup', handleUp);
    };
    window.addEventListener('mousemove', handleMove);
    window.addEventListener('mouseup', handleUp);
};
